import { breakpoints } from 'app/config/grid';
import {
    iterateBreakpointsToObjects,
    getSpacingCSSValue,
    getSharedSpacingCSSValue,
} from 'app/functions/grid';

const getIndexOfName = name => Object.keys(breakpoints).indexOf(name);

const computeSpacing = (value) => {
    if (value === 1) {
        return getSpacingCSSValue();
    }

    if (value === 1 / 2) {
        return getSharedSpacingCSSValue();
    }

    return getSpacingCSSValue(value);
};

/**
 * This function will provide a list of widths (in pixels) which
 * indicate the spacing on different breakpoints (from smallest
 * to biggest).
 *
 * The function expects an object where every key, if present, indicates
 * the spacing to assume in that breakpoint. If a breakpoint is not specified,
 * its spacing will be 0. The value of every key can assume different meanings:
 *
 * - **0** the breakpoint will have no spacing.
 * - **0.5** the breakpoint will have half of the default spacing
 *           that is defined in the application.
 * - **1** the breakpoint will have the default spacing that is defined
 *          in the application.
 * - **any other integer** the breakpoint will have the specified spacing.
 *
 * For example, assume the application defined three breakpoints:
 * small, medium, large. Also, the application has a default spacing of
 * 20 defined for all breakpoints.
 * Calling this function without arguments will return:
 *
 *      [0, 0, 0]
 *
 * If the following object is passed:
 *
 *      {
 *          small: 1
 *          medium: 0.5,
 *          large: 30,
 *      }
 *
 * The function will return:
 *
 *      ['20px', '10px', '30px']
 *
 * @param sizes
 *
 * @todo Implement case when a string is passed, e.g. '1px'
 */
export const buildSpacing = (sizes = {}) =>
    iterateBreakpointsToObjects().reduce((acc, { name }) => [
        ...acc,
        name in sizes ? computeSpacing(sizes[name])[getIndexOfName(name)] : 0,
    ], []);
